import React from 'react';
import { useIntl } from 'react-intl';

const translatedText = (WrappedComponent) => {
  return (props) => {
    const intl = useIntl();
    const translatedTexts = {
      'Login to see your tours': intl.formatMessage({
        id: 'Login to see your tours',
        defaultMessage: 'Login to see your tours',
      }),
      'Login to see your friends tours': intl.formatMessage({
        id: 'Login to see your friends tours',
        defaultMessage: 'Login to see your friends tours',
      }),
      'Login to see your folders': intl.formatMessage({
        id: 'Login to see your folders',
        defaultMessage: 'Login to see your folders',
      }),
    };
    return <WrappedComponent translatedTexts={translatedTexts} {...props} />;
  };
};

export default translatedText;
